import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useContact(): RootState["contact"] {
    const contact = useSelector<RootState, RootState["contact"]>(
        ({ contact }) => contact
    )

    return contact
}
